'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MARKETING_STARTER = exports.MARKETING_STARTER = 'marketingStarter';
var MARKETING_PROFESSIONAL = exports.MARKETING_PROFESSIONAL = 'marketingProfessional';
var MARKETING_PROFESSIONAL_ONBOARDING = exports.MARKETING_PROFESSIONAL_ONBOARDING = 'marketingProfessionalOnboarding';
var MARKETING_ENTERPRISE = exports.MARKETING_ENTERPRISE = 'marketingEnterprise';
var MARKETING_ENTERPRISE_ONBOARDING = exports.MARKETING_ENTERPRISE_ONBOARDING = 'marketingEnterpriseOnboarding';
var SALES_STARTER = exports.SALES_STARTER = 'salesStarter';
var SALES_PROFESSIONAL = exports.SALES_PROFESSIONAL = 'salesProfessional';
var SALES_ENTERPRISE = exports.SALES_ENTERPRISE = 'salesEnterprise';
var SALES_ENTERPRISE_ONBOARDING = exports.SALES_ENTERPRISE_ONBOARDING = 'salesEnterpriseOnboarding';
var SERVICE_STARTER = exports.SERVICE_STARTER = 'serviceStarter';
var SERVICE_PROFESSIONAL = exports.SERVICE_PROFESSIONAL = 'serviceProfessional';
var SERVICE_ENTERPRISE = exports.SERVICE_ENTERPRISE = 'serviceEnterprise';
var SERVICE_ENTERPRISE_ONBOARDING = exports.SERVICE_ENTERPRISE_ONBOARDING = 'serviceEnterpriseOnboarding';
var ADDITIONAL_CONTACTS = exports.ADDITIONAL_CONTACTS = 'additionalContacts';
var ADDITIONAL_USERS = exports.ADDITIONAL_USERS = 'additionalUsers';
var QUICK_START_CONSULTATION = exports.QUICK_START_CONSULTATION = 'quickStartConsultation';
var HSFS_SETUP = exports.HSFS_SETUP = 'hsfsSetup';
var PROFESSIONAL_SUITE_ONBOARDING = exports.PROFESSIONAL_SUITE_ONBOARDING = 'professionalSuiteOnboarding';
var ENTERPRISE_SUITE_ONBOARDING = exports.ENTERPRISE_SUITE_ONBOARDING = 'enterpriseSuiteOnboarding';
var ADDON_BRAND_DOMAIN = exports.ADDON_BRAND_DOMAIN = 'addonBrandDomain';
var ADDON_CMS = exports.ADDON_CMS = 'addonCms';
var ADDON_REPORTING = exports.ADDON_REPORTING = 'addonReporting';
var ADDON_ADS = exports.ADDON_ADS = 'addonAds';
var ADDON_DEDICATED_IP = exports.ADDON_DEDICATED_IP = 'addonDedicatedIp';
var ADDON_TRANSACTIONAL_EMAIL = exports.ADDON_TRANSACTIONAL_EMAIL = 'addonTransactionalEmail';
var ADDON_CUSTOM_SSL = exports.ADDON_CUSTOM_SSL = 'addonCustomSsl';
var ADDON_API = exports.ADDON_API = 'addonApi';
var SERVICE_TRAINING_MARKETING_FUNDAMENTALS = exports.SERVICE_TRAINING_MARKETING_FUNDAMENTALS = 'serviceTrainingMarketingFundamentals';
var SERVICE_INBOUND_CONSULTING_MONTHLY = exports.SERVICE_INBOUND_CONSULTING_MONTHLY = 'serviceInboundConsultingMonthly';
var SERVICE_INBOUND_CONSULTING_ONGOING = exports.SERVICE_INBOUND_CONSULTING_ONGOING = 'serviceInboundConsultingOngoing';
var SERVICE_TECHNICAL_CONSULTING_ONGOING = exports.SERVICE_TECHNICAL_CONSULTING_ONGOING = 'serviceTechnicalConsultingOngoing';
var SERVICE_PREMIUM_CONSULTING = exports.SERVICE_PREMIUM_CONSULTING = 'servicePremiumConsulting';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/constants/BillingNameKeys.js
// module id = 315
// module chunks = 3 4 5